const locale = {
    locale: "fr_FR",
    yearFormat: "YYYY",
    monthFormat: "MMMM",
    fieldDateFormat: "MMM dd yyyy",
    dayFormat: "D",
    shortWeekDays: ["D", "L", "M", "M", "J", "V", "S"],
    monthBeforeYear: true,
};
export default locale;
